import { Directive, Self } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import {
  PhoneNumber,
  PhoneNumberType,
  PhoneNumberUtil,
} from 'google-libphonenumber';
import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';

@Directive({
  selector: 'ngx-intl-tel-input[mobilePhone]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MobilePhoneValidator, multi: true },
  ],
})
export class MobilePhoneValidator implements Validator {
  constructor(@Self() private ngxIntlTelInput: NgxIntlTelInputComponent) {}

  public validate(c: FormControl) {
    const ngx = this.ngxIntlTelInput;
    const util: PhoneNumberUtil = ngx.phoneUtil;

    let number: PhoneNumber;
    try {
      number = util.parseAndKeepRawInput(
        ngx.phoneNumber,
        ngx.selectedCountry.iso2
      );
    } catch (error) {
      return null;
    }
    const type = util.getNumberType(number);

    if (
      type === PhoneNumberType.MOBILE ||
      type === PhoneNumberType.FIXED_LINE_OR_MOBILE
    ) {
      return null;
    } else {
      return { mobile: true };
    }
  }
}
